import React from "react";
import styles from "../../styles/home/CardItem.module.scss";
import homeStyles from "../../styles/home/NewHome.module.scss";

function CardItem({
  imgLink,
  img,
  alt,
  text,
  button,
  buttonCTA,
  title,
  lightText,
}) {
  return (
    <>
      <li className={styles.cardItem}>
        <h1
          className={styles.cardTitle}
          style={{ color: lightText ? "#fff" : "#000" }}
        >
          {title}
        </h1>
        <a className={styles.link} href={imgLink}>
          <img className={styles.img} alt={alt} src={img} />
        </a>
        <div className={styles.info}>
          <h5
            className={styles.text}
            style={{ color: lightText ? "#fff" : "#000" }}
          >
            {text}
          </h5>
          {button && (
            <a href={imgLink} className={homeStyles.buttonWrapper}>
              <button className={homeStyles.button}>{buttonCTA}</button>
            </a>
          )}
        </div>
      </li>
    </>
  );
}

export default CardItem;
